import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class BinaKullanimTuruAPI extends BaseAPI {
    constructor() {
        const baseUrl =
            environment.API_URL + "BinaKullanimTuruListe";
        super(baseUrl);
    }

    getBinaKullanimTuruListe(binaKullanimTuruKodu?: number) {
        return this.get("", { params: { binaKullanimTuruKodu: binaKullanimTuruKodu } });

    }
}
export default new BinaKullanimTuruAPI();